import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import i18n from '@/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ColorModuleTitle',
  props: {
    activeTab: { type: [String, Boolean], default: false }
  },
  setup(__props: any) {

const props = __props as { activeTab: string | boolean };



const colorModuleTitle = computed(() => {
    if (props.activeTab === 'color-request') {
        return i18n.t('Color Request');
    }

    return i18n.t('Color Search');
});

return { __sfc: true,props, colorModuleTitle }
}

})